import { render } from "./PinyinSelect.vue?vue&type=template&id=635154ec"
import script from "./PinyinSelect.vue?vue&type=script&lang=js"
export * from "./PinyinSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/guohongcheng/Documents/jeff/jeff_spn_mini/user_interface/web/vue/tianping/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__